import { useState, useEffect } from 'react';
import { client } from '../api/auth';

export function useAuthImage(filename, refreshTick) {
    const [src, setSrc] = useState(null);

    useEffect(() => {
        let objectUrl = null;
        let cancelled = false;

        const fetchImage = async () => {
            try {
                const response = await client.get(`/data/image/${filename}`, {
                    responseType: 'blob',
                });
                if (!cancelled) {
                    if (objectUrl) URL.revokeObjectURL(objectUrl);
                    objectUrl = URL.createObjectURL(response.data);
                    setSrc(objectUrl);
                }
            } catch (err) {
                console.error(`Failed to load image: ${filename}`, err);
            }
        };

        fetchImage();

        return () => {
            cancelled = true;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [filename, refreshTick]);

    return src;
}
